import { render } from "./ProjectCatalog.vue?vue&type=template&id=90e752fe&scoped=true"
import script from "./ProjectCatalog.vue?vue&type=script&lang=js"
export * from "./ProjectCatalog.vue?vue&type=script&lang=js"

import "./ProjectCatalog.vue?vue&type=style&index=0&id=90e752fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90e752fe"]])

export default __exports__